import { AUTH } from "../Constants/auth";

export const login = (params) => ({
    type: AUTH.LOGIN,
    payload: params
});

export const loadUser = () => ({
    type: AUTH.USER_FETCH
});